import React, { useState, useEffect } from 'react';
import useTheme from './useTheme';
import useWindowSize from './useWindowSize';

var useMediaQuery = function useMediaQuery(_ref) {
  var _ref$above = _ref.above,
      above = _ref$above === undefined ? 0 : _ref$above,
      _ref$below = _ref.below,
      below = _ref$below === undefined ? Infinity : _ref$below;
  var theme = useTheme();

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var _useState = useState(true),
      visible = _useState[0],
      setVisible = _useState[1];

  var breakpoints = theme.griding.breakpoints;

  var _ref2 = breakpoints[above] || {
    width: above || 0
  },
      aboveWidth = _ref2.width;

  var _ref3 = breakpoints[below] || {
    width: below || 0
  },
      belowWidth = _ref3.width;

  var condition = innerWidth >= aboveWidth && innerWidth < belowWidth;
  useEffect(function () {
    setVisible(condition);
  }, [innerWidth]);
  return visible;
};

export default useMediaQuery;